import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import {  ActivatedRoute ,Router} from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonControlService } from 'projects/data-portal/src/app/core/services/common-control.service';
import { CustomSortingService } from 'projects/data-portal/src/app/core/sort/custom-sorting.service';
import { DetailViewerInfoService } from './detail-viewer-info';
import {ViewerService} from '../../../../services/viewer-service';
import { ViewerSearch } from 'projects/data-portal/src/app/models/viewer-search';
import { AppConfigService } from '../../../../core/config/app-config.service';
import { SortableColumn } from 'projects/data-portal/src/app/core/sort/sortable-column';
import {PlottingDetails} from '../../../../models/plotting-map-details'
import { debugOutputAstAsTypeScript } from '@angular/compiler';


@Component({
  selector: 'app-detail-viewer',
  templateUrl: './detail-viewer.component.html',
  styleUrls: ['./detail-viewer.component.css']
})



export class DetailViewerComponent implements OnInit {

  searchFields: FormGroup;  
  columns:string[];
  appealsData: any[];
  errorFromServer: boolean = false;
  formItems: any[];

  pageNumber: number = 1;
  itemsCount: number;
  pageSize: number = 10;
  specififcRTN:string;
  lspLookup:string;
  lspDetail:string;
  chemical:any[];
  responseAction:any[];
  lsp:any[];
  raoDetail:any[];
  tier:any[];
  secondaryRTN:any[];
  relatedRTN:any[];
  loadCompleted :boolean = false;
  isSecondaryRTN :boolean = false;
  public plotingMapData:PlottingDetails[]=[];
  mapCenter:any;
  
  basemapType = 'streets';
  mapZoomLevel = 18;



  protected lspLookupURL = AppConfigService.settings.AppConfig.LSPLOOKUPURL

  responseActionInformationSortableColumns: Array<SortableColumn> = [
    new SortableColumn('responseActionType', 'RESPONSE ACTION TYPE', null,'25%'),
    new SortableColumn('status', 'STATUS', null,'25%'),
    new SortableColumn('submittalDate', 'SUBMITTAL DATE', null, '25%'),
    new SortableColumn('raoClass', 'RAO CLASS', null,'25%'),
    new SortableColumn('activityUseLimitationDate', 'ACTIVITY & USE LIMITATION DATE', null, '25%')
  ];


  chemicalSortableColumns: Array<SortableColumn> = [
    new SortableColumn('chenical', 'CHEMICAL', null,'10%'),
    new SortableColumn('amount', 'AMOUNT', null,'30%'),
    new SortableColumn('units', 'UNITS', null, '30%')
  ];


  lspSortableColumns: Array<SortableColumn> = [
    new SortableColumn('lsp', 'LSP', null,'50%'),
    new SortableColumn('lspNumber', 'LSP NUMBER', null,'50%')
  ];


  raoDetailSortableColumns: Array<SortableColumn> = [
    new SortableColumn('class', 'CLASS', null,'25%'),
    new SortableColumn('method', 'METHOD', null,'25%'),
    new SortableColumn('gwCategory', 'GW CATEGORY', null, '25%'),
    new SortableColumn('soilCategory', 'SOIL CATEGORY', null,'25%')
  ];


  tierClassificationDetailsortableColumns: Array<SortableColumn> = [
    new SortableColumn('zone2', 'ZONE 2', null, '10%'),
    new SortableColumn('imminentHazard', 'IMMINENT HAZARD', null, '10%')
  ];


  secondaryRTNSortableColumns: Array<SortableColumn> = [
    new SortableColumn('secondaryRTN', 'Secondary RTNs', null,'100%')
  ];


  relatedRTNSortableColumns: Array<SortableColumn> = [
    new SortableColumn('primaryRTN', 'PRIMARY RTN', null,'10%'),
    new SortableColumn('secondaryRTN', 'SECONDARY RTN', null,'30%')
  ];



  constructor(private fb: FormBuilder, 
    private router: Router, 
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private SpinnerService: NgxSpinnerService,
    private service: DetailViewerInfoService,
    private commonControlService: CommonControlService,
    private customSortingService: CustomSortingService,
    private viewerService: ViewerService) {

     }


    ngOnInit(): void {
      this.SpinnerService.show();
      
      var secondaryRTN = this.route.snapshot.paramMap.get('secondaryRTN')
      var rtn = this.route.snapshot.paramMap.get('rtn')
     
      this.lspLookup =this.lspLookupURL;
      this.lspDetail=this.lspLookupURL.replace("/search","") + "/";
      var viewerSearch = new ViewerSearch();
      viewerSearch.rtn=rtn;
      this.formItems = this.service.getViewDetailsProperties();
      this.searchFields=this.commonControlService.toFormGroup(this.formItems);
      if(secondaryRTN!=undefined)
      {
        this.isSecondaryRTN=true;
        this.GetDetailsByRTN(secondaryRTN); 
        this.specififcRTN = secondaryRTN;
      }
      else{
        this.GetDetailsByRTN(rtn);
        this.specififcRTN = rtn;
      }

      
       
        
    }
    GetDetailsByRTN(rtn:string) {
      debugger;
      this.viewerService.getDetailsByRTN(rtn,this.route.snapshot.paramMap.get('regulateObjectId'),this.isSecondaryRTN).subscribe((data: any[]) => {
        
        this.formItems.forEach(arrayItem => {
          arrayItem.forEach(item => {
                if (item.type == 'label' && item.key.includes('RTN'))
                item.text =  rtn;
                if (item.type == 'label' && item.key.includes('Category'))
                item.text =  (this.isSecondaryRTN? data['searchResult'][0].category : (this.route.snapshot.paramMap.get('category')!='null'? this.route.snapshot.paramMap.get('category') :''));
                if (item.type == 'label' && item.key.includes('SiteName'))
                item.text = this.isSecondaryRTN ? data['searchResult'][0].siteName :  (this.route.snapshot.paramMap.get('siteName')!='null'? this.route.snapshot.paramMap.get('siteName') :'');
                if (item.type == 'customAULlabel' && item.key.includes('AUL'))
                item.text =  this.isSecondaryRTN ? data['searchResult'][0].aulInfo : (this.route.snapshot.paramMap.get('aulInfo')!='null'?this.route.snapshot.paramMap.get('aulInfo') :'');
                if (item.type == 'label' && item.key.includes('ComplianceStatus'))
                item.text =  this.isSecondaryRTN ? data['searchResult'][0].complianceStatus : (this.route.snapshot.paramMap.get('complianceStatus')!='null'?this.route.snapshot.paramMap.get('complianceStatus') :'');
                if (item.type == 'label' && item.key.includes('Address'))
                item.text = this.isSecondaryRTN ? data['searchResult'][0].address : (this.route.snapshot.paramMap.get('address')!='null'?this.route.snapshot.paramMap.get('address') :'');
                if (item.type == 'labelWithDate' && item.key.includes('Date'))
                item.text = this.isSecondaryRTN ? data['searchResult'][0].date :  (this.route.snapshot.paramMap.get('date')!='null'?this.route.snapshot.paramMap.get('date') :'');;
                if (item.type == 'label' && item.key.includes('TownName'))
                item.text = this.isSecondaryRTN ? data['searchResult'][0].townName : (this.route.snapshot.paramMap.get('townName')!='null'?this.route.snapshot.paramMap.get('townName') :'');;
                if (item.type == 'label' && item.key.includes('ZipCode'))
                item.text = this.isSecondaryRTN ? data['searchResult'][0].zipCode : (this.route.snapshot.paramMap.get('zipCode')!='null'?this.route.snapshot.paramMap.get('zipCode') :'');;
                if (item.type == 'label' && item.key.includes('Phase'))
                item.text = this.isSecondaryRTN ? data['searchResult'][0].phase : (this.route.snapshot.paramMap.get('phase')!='null'?this.route.snapshot.paramMap.get('phase') :'');;
                if (item.type == 'label' && item.key.includes('RAOClass'))
                item.text = this.isSecondaryRTN ? data['searchResult'][0].raoClass : (this.route.snapshot.paramMap.get('raoClass')!='null'?this.route.snapshot.paramMap.get('raoClass') :'');;
                if (item.type == 'labelWithDate' && item.key.includes('NotificationDate'))
                item.text = this.isSecondaryRTN ? data['searchResult'][0].notificationDate : (this.route.snapshot.paramMap.get('notificationDate')!='null'?this.route.snapshot.paramMap.get('notificationDate') :'');;
                if (item.type == 'label' && item.key.includes('LocationType'))
                item.text = this.isSecondaryRTN ? data['searchResult'][0].locationType : (this.route.snapshot.paramMap.get('locationType')!='null'?this.route.snapshot.paramMap.get('locationType') :'');;
                if (item.type == 'labelWithDate' && item.key.includes('InitailStatusDate'))
                item.text = this.isSecondaryRTN ? data['searchResult'][0].initailStatusDate : (this.route.snapshot.paramMap.get('initailStatusDate')!='null'?this.route.snapshot.paramMap.get('initailStatusDate') :'');;
                if (item.type == 'label' && item.key.includes('SourceName'))
                item.text = this.isSecondaryRTN ? data['searchResult'][0].source : (this.route.snapshot.paramMap.get('source')!='null'?this.route.snapshot.paramMap.get('source') :'');;
                if (item.type == 'labelWithDate' && item.key.includes('pipReceived'))
                item.text = this.isSecondaryRTN ? data['searchResult'][0].pipReceived : (this.route.snapshot.paramMap.get('pipReceived')!='null'?this.route.snapshot.paramMap.get('pipReceived') :'');;
            
           });
          });

        this.chemical = data['chemicalResult'];
        this.responseAction= data['responseActionInformationResult'];
        this.lsp=data['lspResult'];
        this.raoDetail=data['raoDetailResult'];
        this.tier=data['tierClassificationDetailResult'];
        this.secondaryRTN=data['secondaryRTNResult'];
        this.relatedRTN=data['relatedRTNResult'];

         

           if( (this.isSecondaryRTN ? data['searchResult'][0].latitude :this.route.snapshot.paramMap.get('latitude'))!='null' && (this.isSecondaryRTN ? data['searchResult'][0].longitude :this.route.snapshot.paramMap.get('longitude'))!='null' )
           {
            this.plotingMapData.push({
              siteName: this.isSecondaryRTN ? data['searchResult'][0].siteName : this.route.snapshot.paramMap.get('siteName'),
              rtn: rtn,
              address: this.isSecondaryRTN ? data['searchResult'][0].address :this.route.snapshot.paramMap.get('address'),
              town:this.isSecondaryRTN ? data['searchResult'][0].townName : this.route.snapshot.paramMap.get('townName'),
              status: this.isSecondaryRTN ? data['searchResult'][0].complianceStatus :this.route.snapshot.paramMap.get('complianceStatus'),
              notes:"Map location approximated by Address Match",
              lat:Number(this.isSecondaryRTN ? data['searchResult'][0].latitude : this.route.snapshot.paramMap.get('latitude')),
              lon:Number(this.isSecondaryRTN ? data['searchResult'][0].longitude : this.route.snapshot.paramMap.get('longitude')),
              siteStatus: this.isSecondaryRTN ? data['searchResult'][0].siteType :this.route.snapshot.paramMap.get('siteType')
            });
            this.mapCenter = [Number( this.isSecondaryRTN ? data['searchResult'][0].longitude :this.route.snapshot.paramMap.get('longitude')),Number(this.isSecondaryRTN ? data['searchResult'][0].latitude :this.route.snapshot.paramMap.get('latitude'))];
           }
           else
           {
            this.SpinnerService.hide();  
            alert("No Longitude and Latitude for this record");
           }
           

        
      }, (err) => {
        this.SpinnerService.hide();
        alert("Internal Server Error - Something went Wrong");
      }
      );
    }

    back(){
      window.history.back();
    }

    mapLoadedEvent(status: boolean) {
      
      console.log('The map has loaded: ' + status);
      this.SpinnerService.hide();  
    }


}
